import React from 'react'
import SubMenuCard from './subMenuCard'
import useStyles from './styles'

interface CardProps {
  closeSubMenu: () => void
  content: { itemName: string; itemUrl: string }
}

const ItsAnEmergencyCard = React.memo(({ closeSubMenu, content }: CardProps) => {
  const { classes } = useStyles()
  return (
    <SubMenuCard
      text={content.itemName}
      route={content.itemUrl}
      className={classes.endCard}
      closeSubMenu={closeSubMenu}
    />
  )
})
ItsAnEmergencyCard.displayName = 'ItsAnEmergencyCard'

const DonateNowCard = React.memo(({ closeSubMenu, content }: CardProps) => {
  const { classes } = useStyles()
  return (
    <SubMenuCard
      text={content.itemName}
      route={content.itemUrl}
      className={classes.endCard}
      closeSubMenu={closeSubMenu}
    />
  )
})

DonateNowCard.displayName = 'DonateNowCard'

export { ItsAnEmergencyCard, DonateNowCard }
